var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsTesti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 7,
    viewBox: "0 0 25 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.25,
    cy: 3.25,
    r: 2.75,
    fill: "white",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.25,
    cy: 3.25,
    r: 2.75,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 6C22.7688 6 24 4.76878 24 3.25C24 1.73122 22.7688 0.5 21.25 0.5C19.7312 0.5 18.5 1.73122 18.5 3.25C18.5 4.76878 19.7312 6 21.25 6Z",
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsTesti);
export default __webpack_public_path__ + "static/media/DotsTesti.68122c02479c2150b167df84679f1dec.svg";
export { ForwardRef as ReactComponent };